module.exports = __webpack_public_path__ + "img/1.e85d2856.png";